<template>
  <v-dialog
    v-model="innerVal"
    max-width="800"
  >
    <DialogCardLayout
      :logo="logo"
      @close="innerVal = false"
      title="Frequently Asked Questions"
    >
      <QuestionItem
        v-for="(item,key) in items"
        :key="key"
        :item="item"
        :class="(key+1)!==items.length?'mb-3':''"
      ></QuestionItem>
    </DialogCardLayout>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ResellerQuestionDialog',

    components: {
      QuestionItem: () => import('./QuestionItem.vue'),
      DialogCardLayout: () => import('./DialogCardLayout.vue')
    },

    props: {
      value: { type:Boolean, default:false },
      items: {
        type: Array,
        default: () => {
          return [];
        }
      },
      logo: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        innerVal: this.value,
        // items: [
        //   {
        //     question: 'Question 1',
        //     answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        //   },
        //   {
        //     question: 'Question 2',
        //     answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        //   },
        //   {
        //     question: 'Question 3',
        //     answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        //   },
        //   {
        //     question: 'Question 4',
        //     answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        //   },
        //   {
        //     question: 'Question 5',
        //     answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        //   },
        //   {
        //     question: 'Question 6',
        //     answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        //   },
        // ]
      }
    },

    watch: {
      value(val) {
        this.innerVal = val
      },
      innerVal(val) {
        this.$emit('input', val)
      }
    },

    methods: {
      //
    }
  }
</script>

<style lang="scss" scoped>

</style>